const formatDeliveryTimestamp = (timestamp?: number) => {
  if (!timestamp) {
    return "an unknown time";
  }
  return new Date(timestamp).toLocaleString();
};

export const formatOnboardingEmailDeliveryError = ({
  purpose,
  email,
  timestamp,
  reason,
}: {
  purpose: string;
  email: string;
  timestamp?: number;
  reason?: string;
}) => {
  const date = formatDeliveryTimestamp(timestamp);
  const reasonText = reason?.trim() || "Unknown";

  return `We were not able to deliver the ${purpose} email to ${email} at ${date}. Reason: ${reasonText}. Check the email address and try sending it again.`;
};
